import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ChartContainer, ChartTooltip } from '@/components/ui/chart'

interface CategoryScore {
  category: string
  managerScore: number
  directReportScore: number
}

interface AssessmentRadarChartProps {
  data: Array<CategoryScore>
}

const chartConfig = {
  managerScore: {
    label: 'Manager',
    color: 'var(--chart-1)',
  },
  directReportScore: {
    label: 'Direct Report',
    color: 'var(--chart-2)',
  },
}

export function AssessmentRadarChart({ data }: AssessmentRadarChartProps) {
  return (
    <Card className="h-full p-6 bg-muted/30 rounded-lg border-none shadow-none">
      <CardHeader className="p-0 mb-4">
        <CardTitle className="text-lg font-semibold">
          Feedback Radar Chart
        </CardTitle>
      </CardHeader>
      <CardContent className="h-full p-0">
        <ChartContainer config={chartConfig} className="h-full w-full">
          <RadarChart data={data}>
            <ChartTooltip
              cursor={false}
              contentStyle={{
                backgroundColor: 'var(--background)',
                borderColor: 'var(--border)',
                color: 'var(--foreground)',
              }}
              formatter={(value) => {
                const n = typeof value === 'number' ? value : Number(value)
                return Number.isFinite(n) ? n.toFixed(2) : '0.00'
              }}
              labelFormatter={(label) => `${label}`}
            />
            <PolarAngleAxis
              dataKey="category"
              tick={{ fontSize: 16, fill: 'var(--foreground)' }}
            />
            <PolarGrid />
            <Radar
              animationDuration={1000}
              dataKey="managerScore"
              name="Manager"
              fill="var(--color-managerScore)"
              fillOpacity={0.6}
              stroke="var(--color-managerScore)"
            />
            <Radar
              animationDuration={1000}
              dataKey="directReportScore"
              name="Direct Report"
              fill="var(--color-directReportScore)"
              fillOpacity={0.6}
              stroke="var(--color-directReportScore)"
            />
          </RadarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
